import React, { useState } from 'react';
import {
  Box, Typography, Card, CardContent, TextField,
  Button, Alert, CircularProgress
} from '@mui/material';
import { submitReport } from '../services/api';

export default function Report() {
  const [form, setForm] = useState({
    spend: '', ctr: '', roas: '', top_product: '', observation: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    setSuccess('');
    setResult(null);
    try {
      const res = await submitReport({
        spend: parseFloat(form.spend),
        ctr: parseFloat(form.ctr),
        roas: parseFloat(form.roas),
        top_product: form.top_product,
        observation: form.observation
      });
      setResult(res.data);
      setSuccess('Report submitted and analyzed successfully');
      setForm({ spend: '', ctr: '', roas: '', top_product: '', observation: '' });
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to submit report');
    } finally {
      setLoading(false);
    }
  };

  const allFilled = Object.values(form).every(v => v.toString().trim() !== '');

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" color="#fff" mb={3}>
        Submit Report
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

      <Card sx={{ background: '#1a2633', border: '1px solid #2d3f50', mb: 3 }}>
        <CardContent>
          <Typography color="#8899aa" variant="body2" mb={3}>
            Fill in your campaign results. All fields are required.
          </Typography>
          <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2} mb={2}>
            <TextField
              label="Ad Spend ($)" name="spend" type="number"
              value={form.spend} onChange={handleChange}
              sx={{ input: { color: '#fff' }, label: { color: '#8899aa' } }}
            />
            <TextField
              label="CTR (%)" name="ctr" type="number"
              value={form.ctr} onChange={handleChange}
              sx={{ input: { color: '#fff' }, label: { color: '#8899aa' } }}
            />
            <TextField
              label="ROAS" name="roas" type="number"
              value={form.roas} onChange={handleChange}
              sx={{ input: { color: '#fff' }, label: { color: '#8899aa' } }}
            />
            <TextField
              label="Top Performing Product" name="top_product"
              value={form.top_product} onChange={handleChange}
              sx={{ input: { color: '#fff' }, label: { color: '#8899aa' } }}
            />
          </Box>
          <TextField
            fullWidth multiline rows={3}
            label="Observation / Notes" name="observation"
            value={form.observation} onChange={handleChange}
            sx={{ mb: 3, textarea: { color: '#fff' }, label: { color: '#8899aa' } }}
          />
          <Button
            variant="contained" fullWidth
            disabled={loading || !allFilled}
            onClick={handleSubmit}
            sx={{ background: '#2563eb', py: 1.5, fontWeight: 'bold' }}
          >
            {loading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Submit Report'}
          </Button>
        </CardContent>
      </Card>

      {result && (
        <Card sx={{ background: '#1a2633', border: '1px solid #2d3f50' }}>
          <CardContent>
            <Typography color="#fff" fontWeight="bold" mb={2}>
              Analysis Result
            </Typography>
            <Typography color="#8899aa" variant="body2" mb={1}>
              {result.summary}
            </Typography>
            {result.flags?.map((f, i) => (
              <Box key={i} sx={{
                background: f.severity === 'red' ? '#3b0a0a' : '#1a2a0a',
                p: 1, borderRadius: 1, mb: 1
              }}>
                <Typography
                  variant="body2"
                  color={f.severity === 'red' ? '#f87171' : '#86efac'}
                >
                  {f.severity.toUpperCase()}: {f.type}
                </Typography>
              </Box>
            ))}
          </CardContent>
        </Card>
      )}
    </Box>
  );
}
